import { PointerSensor } from '@dnd-kit/core';

/**
 * An extended "PointerSensor" that prevent some
 * interactive html element(button, input, textarea, select, option...) from dragging
 * and also prevent dragging when the element has "data-no-dnd" attribute
 */
class SmartPointerSensor extends PointerSensor {}
SmartPointerSensor.activators = [{
  eventName: 'onPointerDown',
  handler: ({
    nativeEvent: event
  }) => {
    let eventTarget = event.target;
    if (!event.isPrimary || event.button !== 0 || isInteractiveElement(eventTarget)) {
      return false;
    }
    while (eventTarget) {
      const currentEventTarget = eventTarget;
      if (currentEventTarget.dataset.noDnd) {
        return false;
      }
      eventTarget = currentEventTarget.parentElement;
    }
    return true;
  }
}];
function isInteractiveElement(element) {
  const interactiveElements = ['button', 'input', 'textarea', 'select', 'option', 'a'];
  if ((element === null || element === void 0 ? void 0 : element.tagName) && interactiveElements.includes(element.tagName.toLowerCase())) {
    return true;
  }
  return false;
}
const pointerSensorOptions = hasRowOnClick => hasRowOnClick ? {
  activationConstraint: {
    distance: 1
  }
} : undefined;

export { SmartPointerSensor, pointerSensorOptions };
//# sourceMappingURL=dnd-kit.js.map
